[
  {
    "code": "SY-HA",
    "name": "Al Hasakah"
  },
  {
    "code": "SY-LA",
    "name": "Al Ladhiqiyah"
  },
  {
    "code": "SY-QU",
    "name": "Al Qunaytirah"
  },
  {
    "code": "SY-RA",
    "name": "Ar Raqqah"
  },
  {
    "code": "SY-SU",
    "name": "As Suwayda'"
  },
  {
    "code": "SY-DR",
    "name": "Dar‘a"
  },
  {
    "code": "SY-DY",
    "name": "Dayr az Zawr"
  },
  {
    "code": "SY-DI",
    "name": "Dimashq"
  },
  {
    "code": "SY-HL",
    "name": "Halab"
  },
  {
    "code": "SY-HM",
    "name": "Hamah"
  },
  {
    "code": "SY-HI",
    "name": "Hims"
  },
  {
    "code": "SY-ID",
    "name": "Idlib"
  },
  {
    "code": "SY-RD",
    "name": "Rif Dimashq"
  },
  {
    "code": "SY-TA",
    "name": "Tartus"
  }
]